import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ReactMapGL, { Popup, LinearInterpolator } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { WebMercatorViewport } from '@deck.gl/core';
import DeckGL, { IconLayer } from 'deck.gl';
import PINS from '../../assets/images/pins.svg';
import _ from 'lodash'
import { autorun } from 'mobx';

@inject('userStore')
@observer
class ShipmentTooltip extends Component {
  render() {
    const { shipment, userStore } = this.props;
    const { blurCustomerInfo, blurCustomerAddress } = userStore;

    const blurInfoStyle = blurCustomerInfo ? { color: 'transparent', textShadow: '0 0 10px rgba(0, 0, 0, 0.6)' } : {};
    const blurAddressStyle = blurCustomerAddress ? { color: 'transparent', textShadow: '0 0 10px rgba(0, 0, 0, 0.6)' } : {};

    return (
      <div style={{ minWidth: '200px', fontSize: '13px' }}>
        <div style={blurInfoStyle}>
          <b>{shipment.customer.name}</b>
        </div>
        <div style={{ color: '#888', ...blurInfoStyle }}>{shipment.customer.phone_number}</div>
        <div style={{ color: '#888', marginBottom: '4px', ...blurInfoStyle }}>{shipment.customer.email}</div>
        <div style={blurAddressStyle}>
          {shipment.dropoff_address.street} {shipment.dropoff_address.street2 ? ', ' + shipment.dropoff_address.street2 : ''}
        </div>
        <div>
          {shipment.dropoff_address.city}, {shipment.dropoff_address.state} {shipment.dropoff_address.zipcode}
        </div>
      </div>
    );
  }
}

@inject('jobStore')
class JobMapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      zoom: 13,
      viewport: {
        latitude: 37.7577,
        longitude: -122.4376,
        zoom: 11
      },
      layers: [],
      mapStyle: `https://api.maptiler.com/maps/${import.meta.env.REACT_APP_MAP_TILER_STYLE}/style.json?key=${import.meta.env.REACT_APP_MAP_TILER_KEY}`
    };


    this.iconMapping = {};
    const iconW = 112, iconH = 340, iconAnchor = 312;
    this.iconMapping['shadow'] = {
        x: 0, y: iconH, width: 264, height: iconH, anchorY: iconAnchor, anchorX: iconW / 2
    };
    this.iconMapping['succeeded'] = {
        x: 0, y: 0, width: iconW, height: iconH, anchorY: iconAnchor
    };
    this.iconMapping['failed'] = {
        x: iconW, y: 0, width: iconW, height: iconH, anchorY: iconAnchor
    };
    this.iconMapping['inprogress'] = {
        x: iconW * 2, y: 0, width: iconW, height: iconH, anchorY: iconAnchor
    };
    this.iconMapping['pending'] = {
        x: iconW * 3, y: 0, width: iconW, height: iconH, anchorY: iconAnchor
    };
    this.iconMapping['unrouted'] = {
        x: iconW * 4, y: 0, width: iconW, height: iconH, anchorY: iconAnchor
    };

    this.showShipmentTooltip = this.showShipmentTooltip.bind(this);
  }

  componentDidMount() {
    this.markerDisposer = autorun(() => {
      const { jobStore } = this.props;
      const { selectedJob, selectedShipment, selectedJobShipments } = jobStore;
      const shipments = selectedJobShipments;


      if (shipments && shipments.length > 0) {
        this.setState({layers: this._processDropoffMap(shipments, selectedShipment)})
      }
    }, {delay: 100});

    this.boundaryDisposer = autorun(() => {
      const { jobStore } = this.props;
      const { boundary } = jobStore;

      if (!boundary)
        return;

      this.fitBoundary(boundary)
    }, {delay: 100})
  }

  fitBoundary(boundary) {
    if (this.currentBoundary && this.currentBoundary === boundary) {
      return
    }

    if (this.currentBoundary) {
      if (
        Math.abs(boundary[0][0] - this.currentBoundary[0][0]) < 0.0002
        && Math.abs(boundary[0][1] - this.currentBoundary[0][1]) < 0.0002
        && Math.abs(boundary[1][1] - this.currentBoundary[1][1]) < 0.0002
        && Math.abs(boundary[1][0] - this.currentBoundary[1][0]) < 0.0002
      )
      return;
    }
    this.currentBoundary = boundary;

    if (!this.state.viewport)
      return;
    // too small box
    let isTooSmall = boundary[1][0] -  boundary[0][0] < 0.0004;
    let c = { longitude: boundary[0][1], latitude: boundary[0][0], zoom: 15};
    const viewport = new WebMercatorViewport(this.state.viewport);

    let { longitude, latitude, zoom } = isTooSmall ? c : viewport.fitBounds(
        boundary.slice().map(b => b.slice()),
        { padding: 40 }
    );



    this.setState({
      viewport: {
        ...this.state.viewport,
        longitude,
        latitude,
        zoom,
        transitionDuration: 500
      }
    });
  }

  componentWillUnmount() {
    if (this.markerDisposer) this.markerDisposer();
    if (this.boundaryDisposer) this.boundaryDisposer();
  }

  showShipmentTooltip(shipment) {
    this.setState({hoveredShipment: shipment})
  }

  selectShipment(shipment) {
    const { jobStore } = this.props;
    jobStore.selectedShipment = shipment;
  }

  _renderShipmentTooltip() {
    const { hoveredShipment } = this.state;
    return hoveredShipment && (
        <Popup tipSize={5}
            anchor="bottom"
            closeButton={false}
            longitude={ hoveredShipment.location[0] }
            latitude={ hoveredShipment.location[1] }
            offsetTop={-40}
            className={'map-tooltip'}
            onClose={() => this.setState({ hoveredStop: null })} >
            <ShipmentTooltip shipment={ hoveredShipment.shipment } />
        </Popup>
    );
  }

  _markerIcon(shipment) {
    // if (_.isNil(shipment.assignment_id)) return 'unrouted';
    const map = {
      DROPOFF_SUCCEEDED: 'succeeded',
      DROPOFF_FAILED: 'failed',
      PICKUP_FAILED: 'failed',
      DROPOFF_READY: 'inprogress',
      PICKUP_SUCCEEDED: 'inprogress',
    };
    return _.defaultTo(map[shipment.status], 'inprogress')
  }

  _processDropoffMap(shipments, selected) {
    const validShipments = _.sortBy(shipments.slice(), s => -s.dropoff_address.lat)
      .filter(sh => !!sh.dropoff_address.lat && !!sh.dropoff_address.lng);

    const shadows = validShipments.flatMap(s => [
      {
          location: [s.dropoff_address.lng, s.dropoff_address.lat],
          size: 40,
          icon: 'shadow'
      }
    ]);
    const icons = validShipments.flatMap(s => [
      {
          location: [s.dropoff_address.lng, s.dropoff_address.lat],
          shipment: s,
          size: 40,
          icon: this._markerIcon(s)
      }
    ]);
    const dropoffMarkers = shadows.concat(icons);

    const dropoffIconlayer = new IconLayer({
        id: 'dropoff-icon-layer',
        data: dropoffMarkers,
        pickable: true,
        // iconAtlas and iconMapping are required
        // getIcon: return a string
        iconAtlas: PINS,
        iconMapping: this.iconMapping,
        getIcon: d => d.icon,
        sizeScale: 1,
        opacity: selected ? 0.25 : 1,
        visible: true,
        getPosition: d => d.location,
        getSize: d => d.size,
        onHover: (info) => {
          const {object} = info;
          if (object && object.shipment)
            this.showShipmentTooltip(object);
          if (!object)
            this.showShipmentTooltip(null)
        },
        onClick: (info) => {
          const {object} = info;
          if (object && object.shipment)
            this.selectShipment(object.shipment);
          if (!object)
            this.selectShipment(null)
        }
    });

    const selectedIcon = selected ? [
      new IconLayer({
          id: 'selected-dropoff-icon-layer',
          data: [
            {
              location: [selected.dropoff_address.lng, selected.dropoff_address.lat],
              shipment: selected,
              size: 40,
              icon: this._markerIcon(selected)
            }
          ],
          pickable: true,
          // iconAtlas and iconMapping are required
          // getIcon: return a string
          iconAtlas: PINS,
          iconMapping: this.iconMapping,
          getIcon: d => d.icon,
          sizeScale: 1,
          opacity: 1,
          visible: true,
          getPosition: d => d.location,
          getSize: d => d.size,
          onHover: (info) => {
            const {object} = info;
            if (object && object.shipment)
              this.showShipmentTooltip(object);
            if (!object)
              this.showShipmentTooltip(null)
          },
          onClick: () => {
            this.selectShipment(null)
          }
      })
    ] : [];


    return [dropoffIconlayer].concat(selectedIcon);
  }

  render() {
    const { latitude, longitude, zoom, bearing, pitch } = this.state.viewport;
    const deckViewState = {
      latitude,
      longitude,
      zoom,
      bearing,
      pitch
    };
    return <ReactMapGL
        {...this.state.viewport}
        mapStyle={this.state.mapStyle}
        transitionInterpolator={new LinearInterpolator()}
        onViewportChange={(viewport) => this.setState({ viewport })}
        width={'100%'}
        height={'100%'}
        ref={map => this.mapRef = map}
    >
      <DeckGL
        onClick={(info) => {
          if (!info || !info.object) {
            this.setState({ hoveredShipment: null })
          }
        }}
        viewState={deckViewState}
        controller={true}
        layers={this.state.layers}
      />
      { this._renderShipmentTooltip() }
    </ReactMapGL>
  }
}

export default JobMapContainer
